class RecentlyViewed extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.expireDay = this.popup.getAttribute('data-expire-day');
        this.limit = this.popup.getAttribute('data-product-to-show');
        this.icon = this.getElementsByClassName('recently-viewed-icon');
        this.tab = this.getElementsByClassName('recently-viewed-tab');
        this.noProduct = this.getElementsByClassName('no-products')[0],
            this.iconClose = this.getElementsByClassName('button__close');


        const recentlyViewed = $(this.popup);

        Shopify.Products.recordRecentlyViewed();

        var cookieValue = $.cookie('shopify_recently_viewed');
        if (!cookieValue) {
            // The recorder writes both the cookie AND localStorage; when
            // cookies are unavailable/expired the queue may only live there.
            try { cookieValue = window.localStorage.getItem('shopify_recently_viewed'); } catch (error) {}
        }

        if (!(cookieValue !== null && cookieValue !== undefined && cookieValue !== "")) {
            if (!this.showFallbackProducts()) {
                this.noProduct ? this.noProduct.style.display = 'flex' : null;
            }
            this.popup.classList.add('is-show');
        } else {
            var limit = this.limit,
                expireDay = this.expireDay;

            Shopify.Products.showRecentlyViewed({
                howManyToShow: limit,
                wrapperId: 'recently-viewed-products-list',
                templateId: 'recently-viewed-product-popup',
                onComplete: () => {
                    recentlyViewed.find('.no-products').remove();
                    recentlyViewed.addClass('is-show');

                    this.setupGrid();

                    if (window.location.pathname.indexOf('/products/') !== -1) {
                        $.cookie('shopify_recently_viewed', cookieValue, { expires: expireDay, path: "/", domain: window.location.hostname });
                    }
                }
            });
        }

        $('#recently-viewed-products-share').on('click', '[data-open-newsletter-popup]', (event) => {
            event.preventDefault();

            document.body.classList.add('newsletter-show');
            setTimeout(() => {
                document.body.classList.add('show-newsletter-image');
            }, 700)
        });

        for (let i = 0; i < this.icon.length; i++) {
            this.icon[i].addEventListener('click', this.popup.iconClick.bind(this));
        }

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        for (let i = 0; i < this.iconClose.length; i++) {
            this.iconClose[i].addEventListener('click', this.popup.closeDetails.bind(this));
        }

        this.dismissKey = 'halo-recently-viewed-dismissed';
        this.wrap = document.getElementById('halo-recently-viewed-wrap');
        try {
            if (window.sessionStorage.getItem(this.dismissKey)) this.popup.classList.add('is-dismissed');
        } catch (error) {}
        this.bindHistorySlot(cookieValue);
        if (this.wrap) {
            this.restoreStackPosition();
            this.bindStackGestures();
        }
        this.bindSheetSwipe();
    }

    // Phones/tablets have little room: the recently-viewed slot only unfolds once
    // there is history beyond the product on screen (that one was recorded just
    // above, so it is always in the queue). Desktop keeps the fallback collection.
    bindHistorySlot(queueValue) {
        const slot = this.querySelector('.recently-viewed-icon[data-target="halo-recently-viewed-list"]');
        if (!slot) return;

        const match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
        const current = match ? decodeURIComponent(match[1]) : null;
        const hasHistory = (queueValue || '').split(' ').some(handle => handle && handle !== current);
        const compact = window.matchMedia('(max-width: 1024px)');
        const update = () => slot.classList.toggle('is-collapsed', compact.matches && !hasHistory);

        update();
        compact.addEventListener('change', update);
    }

    // The stack's height on screen, chosen by the visitor (hold + drag), kept as a
    // share of the viewport height so it survives rotation.
    restoreStackPosition() {
        this.positionKey = 'halo-recently-viewed-y';
        let ratio = NaN;
        try { ratio = parseFloat(window.localStorage.getItem(this.positionKey)); } catch (error) {}
        if (!(ratio > 0 && ratio < 1)) return;

        const place = () => this.placeStack(ratio * window.innerHeight);
        place();
        window.addEventListener('resize', place, { passive: true });
    }

    // Centre the stack at viewport y, kept clear of the sticky search bar at the
    // top and the browser toolbar at the bottom (sized for every slot unfolded).
    placeStack(y) {
        const half = this.wrap.querySelectorAll('.recently-viewed-icon').length * 18 + 2;
        const bar = document.querySelector('.header-mobile__search');
        const min = (bar ? bar.offsetHeight : 0) + 8 + half;
        const max = Math.max(min, window.innerHeight - 64 - half);
        const top = Math.min(Math.max(y, min), max);

        this.popup.style.top = `${top}px`;
        return top;
    }

    // Shared between real recently-viewed results and the fallback
    // collection: arrow state + desktop hover-preview wiring.
    setupGrid() {
        var recentlyViewed = $(this.popup),
            recentlyGrid = recentlyViewed.find('.products-grid'),
            productGrid = recentlyGrid.find('.item');

        if (productGrid.length > 0) {
            if (recentlyGrid.is(':visible')) {
                if (window.innerWidth < 767) {
                    if (productGrid.length > 2) {
                        recentlyGrid.addClass('has-arrow');
                    }
                } else {
                    if (productGrid.length > 3) {
                        recentlyGrid.addClass('has-arrow');
                    }
                }
            }
        }
        recentlyGrid.on('mouseenter', '.item', (event) => {
            event.preventDefault();

            var $currTarget = $(event.currentTarget),
                current = recentlyGrid.find('.slick-active'),
                index = current.index($currTarget),
                content = $currTarget.find('.second-info').html(),
                productInfo = $('.product-info', recentlyGrid),
                marginTop = Math.abs(index) * productInfo.outerHeight();

            productInfo
                .html(content)
                .css('margin-top', marginTop)
                .show();
        });

        recentlyGrid.on('mouseenter', '.slick-arrow', (event) => {
            $('.product-info', recentlyGrid).hide();
        });

        recentlyGrid.on('click', 'a[data-mobile-click]', (event) => {
            if (window.innerWidth < 768) {
                event.preventDefault();
            }
        });
    }

    // When the visitor has nothing in the queue, show the Liquid-rendered
    // fallback collection instead. Returns true when products were injected.
    showFallbackProducts() {
        const template = this.querySelector('template[data-recently-viewed-fallback]');
        const wrapper = document.getElementById('recently-viewed-products-list');

        if (!template || !wrapper) return false;

        wrapper.appendChild(template.content.cloneNode(true));

        const title = this.querySelector('.recently-viewed-title');
        if (title && template.dataset.fallbackTitle) {
            title.textContent = template.dataset.fallbackTitle;
        }

        $(this.popup).find('.no-products').remove();
        this.setupGrid();
        return true;
    }

    // Touch gestures on the floating stack:
    //  - swipe right: hide it for the rest of the session;
    //  - hold, then drag up/down: move it out of the way (remembered on this device).
    // A vertical move before the hold fires is a page scroll and is left alone.
    bindStackGestures() {
        const HOLD_MS = 350, SLOP = 6;
        let startX = 0, startY = 0, deltaX = 0, startTop = 0, top = 0, holdTimer = 0;
        let mode = null; // null until decided, then 'swipe' | 'move' | 'scroll'

        const cancelHold = () => {
            clearTimeout(holdTimer);
            holdTimer = 0;
        };

        this.wrap.addEventListener('touchstart', (event) => {
            if (event.touches.length !== 1) return;
            startX = event.touches[0].clientX;
            startY = event.touches[0].clientY;
            deltaX = 0;
            mode = null;
            cancelHold();
            holdTimer = setTimeout(() => {
                holdTimer = 0;
                if (mode) return;
                mode = 'move';
                const rect = this.popup.getBoundingClientRect();
                startTop = top = (rect.top + rect.bottom) / 2;
                this.popup.classList.add('is-moving');
            }, HOLD_MS);
        }, { passive: true });

        // Not passive: once moving, the drag must not scroll the page.
        this.wrap.addEventListener('touchmove', (event) => {
            const dx = event.touches[0].clientX - startX;
            const dy = event.touches[0].clientY - startY;

            if (mode === 'move') {
                event.preventDefault();
                top = this.placeStack(startTop + dy);
                return;
            }
            if (!mode) {
                if (Math.abs(dx) < SLOP && Math.abs(dy) < SLOP) return;
                cancelHold();
                mode = Math.abs(dy) > Math.abs(dx) ? 'scroll' : 'swipe';
            }
            if (mode !== 'swipe') return;

            deltaX = Math.max(dx, 0);
            this.popup.style.transition = 'none';
            this.popup.style.transform = `translate3d(${deltaX}px, -50%, 0)`;
        }, { passive: false });

        const endGesture = (event) => {
            cancelHold();
            if (mode === 'move') {
                // A hold-and-drag never counts as a tap on the slot under the finger.
                if (event.cancelable) event.preventDefault();
                this.popup.classList.remove('is-moving');
                try { window.localStorage.setItem(this.positionKey, String(top / window.innerHeight)); } catch (error) {}
            } else if (mode === 'swipe') {
                this.popup.style.transition = '';
                this.popup.style.transform = '';
                if (deltaX > 30) {
                    this.popup.classList.add('is-dismissed');
                    try { window.sessionStorage.setItem(this.dismissKey, '1'); } catch (error) {}
                }
            }
            mode = null;
            deltaX = 0;
        };
        this.wrap.addEventListener('touchend', endGesture);
        this.wrap.addEventListener('touchcancel', endGesture);
        // Android opens a context menu on a long press.
        this.wrap.addEventListener('contextmenu', event => event.preventDefault());
    }

    // Drag the mobile bottom sheet down (from its grabber/header) to close.
    bindSheetSwipe() {
        const sheet = document.querySelector('.recently-viewed-popup-mb');
        if (!sheet) return;

        let startY = 0, deltaY = 0, active = false;

        sheet.addEventListener('touchstart', (event) => {
            if (event.touches.length !== 1) return;
            // Only the grabber/header region drags, so the gesture never
            // fights the horizontal product scroller below it.
            if (!event.target.closest('.recently-header') && event.target !== sheet) return;
            startY = event.touches[0].clientY;
            deltaY = 0;
            active = true;
            sheet.style.transition = 'none';
        }, { passive: true });

        sheet.addEventListener('touchmove', (event) => {
            if (!active) return;
            deltaY = Math.max(event.touches[0].clientY - startY, 0);
            sheet.style.transform = `translateY(${deltaY}px)`;
        }, { passive: true });

        const endDrag = () => {
            if (!active) return;
            sheet.style.transition = '';
            sheet.style.transform = '';
            if (deltaY > 80) {
                document.body.classList.remove('recently-popup-mb-show');
                this.closeTab();
            }
            active = false;
            deltaY = 0;
        };
        sheet.addEventListener('touchend', endDrag);
        sheet.addEventListener('touchcancel', endDrag);
    }

    iconClick(event) {
        var $currTarget = event.currentTarget,
            $recentlyViewed = this.popup;

        if ($currTarget.classList.contains('open-popup')) {
            var currPopup = $currTarget.getAttribute('data-target');

            if ($currTarget.classList.contains('is-open')) {
                $currTarget.classList.remove('is-open');
                document.getElementById(currPopup)?.classList.remove('is-visible');
                document.querySelector('body').classList.remove('recently-popup-mb-show');
            } else {
                this.closeTab();
                $currTarget.classList.add('is-open');
                document.getElementById(currPopup)?.classList.add('is-visible');
                const recentlyGrid = $(`#${currPopup}`).find('.products-grid');

                if (window.innerWidth < 1025) {
                    document.querySelector('body').classList.add('recently-popup-mb-show');
                    $('.recently-viewed-popup-mb .halo-recently-viewed').hide();
                    if ($('.recently-viewed-popup-mb').find(`#${currPopup}`).length) {
                        $(`#${currPopup}`).show();
                    }
                    else {
                        $('.recently-viewed-popup-mb').append($(document.getElementById(currPopup)));
                    }
                    if (currPopup == 'halo-recently-viewed-list' && recentlyGrid.hasClass('slick-initialized')) {
                        recentlyGrid.slick('unslick');
                        recentlyGrid.find('.product-info').remove();
                    }
                } else {
                    $('.halo-recently-viewed-popup').append($('.recently-viewed-popup-mb .halo-recently-viewed'));
                    if (currPopup == 'halo-recently-viewed-list' && !recentlyGrid.hasClass('slick-initialized')) {
                        const productGrid = recentlyGrid.find('.item');
                        if (productGrid.length > 2) {
                            recentlyGrid.slick({
                                infinite: false,
                                speed: 1000,
                                slidesToShow: 3,
                                dots: false,
                                arrows: true,
                                vertical: true,
                                slidesToScroll: 1,
                                adaptiveHeight: true,
                                nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><title>ic-arrow-right</title><path d="M15.111 12L8 4.889 8.889 4l8 8-8 8L8 19.111z"></path></svg></button>',
                                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><title>ic-arrow-left</title><path d="M8.778 12l7.111-7.111L15 4l-8 8 8 8 .889-.889z"></path></svg></button>',
                                responsive: [
                                    {
                                        breakpoint: 768,
                                        settings: {
                                            slidesToScroll: 1,
                                            slidesToShow: 1
                                        }
                                    }
                                ]
                            });
                        } else if (productGrid.length > 1) {
                            recentlyGrid.slick({
                                infinite: false,
                                speed: 1000,
                                slidesToShow: 2,
                                dots: false,
                                arrows: true,
                                vertical: true,
                                slidesToScroll: 1,
                                adaptiveHeight: true,
                                nextArrow: '<button type="button" class="slick-next" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><title>ic-arrow-right</title><path d="M15.111 12L8 4.889 8.889 4l8 8-8 8L8 19.111z"></path></svg></button>',
                                prevArrow: '<button type="button" class="slick-prev" aria-label="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"><title>ic-arrow-left</title><path d="M8.778 12l7.111-7.111L15 4l-8 8 8 8 .889-.889z"></path></svg></button>',
                                responsive: [
                                    {
                                        breakpoint: 768,
                                        settings: {
                                            slidesToScroll: 1,
                                            slidesToShow: 1
                                        }
                                    }
                                ]
                            });
                        }

                        if (productGrid.length == 0) recentlyGrid.addClass('not-product');
                        recentlyGrid.prepend('<div class="product-info"></div>');
                    }
                }
            }
        }

        if (document.body.classList.contains('recently-popup-mb-show')) {
            document.querySelector('.background-overlay').addEventListener('click', this.closeDetails.bind(this));
        }
    }

    closeDetails(event) {
        event.preventDefault();
        event.stopPropagation();

        if (document.body.classList.contains('ask-an-expert-show')) {
            document.querySelector('body').classList.remove('ask-an-expert-show');
        }
        document.querySelector('body').classList.remove('recently-popup-mb-show');
        this.closeTab();
    }


    closeTab() {
        for (let i = 0; i < this.icon.length; i++) {
            this.icon[i].classList.remove('is-open');
        }

        for (let i = 0; i < this.tab.length; i++) {
            this.tab[i].classList.remove('is-visible');
        }
    }

    onBodyClickEvent(event) {
        if (!this.contains(event.target)) {
            this.closeTab();
        }
    }
}

customElements.define('recently-viewed-popup', RecentlyViewed);

class BackToTopButton extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.sideIcons = [...document.getElementsByClassName('recently-viewed-icon')];

        this.addEventListener('click', e => {
            e.preventDefault();

            this.sideIcons.forEach(icon => {
                const popup = document.getElementById(icon.dataset.target);

                if (!popup) return;

                popup.classList.remove('is-open');
                popup.classList.remove('is-visible');
            })

            $('html, body').animate({
                scrollTop: 0
            }, 700);

        })

        window.addEventListener('scroll', this.onScroll.bind(this), { passive: true });
        this.onScroll();
    }

    // Folds away near the top of the page and unfolds once there is a way back up.
    onScroll() {
        const currentTop = window.pageYOffset || document.body.scrollTop;
        const pageHeight = document.body.scrollHeight;

        this.classList.toggle('is-collapsed', currentTop / pageHeight <= 0.07);
    }
}

customElements.define('back-to-top-button', BackToTopButton);